import React from 'react';
import { AddButton, Banner, Button } from '@fourthwall/components';
import { PaymentMethodsList } from '@modules/Dashboard/modules/PaymentMethods/components/PaymentMethodsList/PaymentMethodsList';
import * as S from '@modules/Dashboard/modules/PaymentMethods/modules/PaymentMethodRequiredModal/PaymentMethodRequiredModal.styled';
import { AddPaymentMethod } from '../AddPaymentMethod';
export const SelectPaymentMethodView = ({ viewType, submitLabel, withChargeLimit, paymentMethodsProps, errorBanner, isSubmitting, isDisabled, isLoading, onAddPaymentMethod, onSuccess, onSubmit, children, }) => {
    const renderPaymentMethods = () => {
        return (React.createElement(React.Fragment, null,
            errorBanner && (React.createElement(S.ErrorBannerContainer, null,
                React.createElement(Banner, { appearance: "danger" }, errorBanner))),
            paymentMethodsProps && (React.createElement(S.PaymentMethodsContainer, null,
                React.createElement(PaymentMethodsList, { paymentMethods: paymentMethodsProps, selectable: true }))),
            React.createElement(AddButton, { label: "Add new payment method", onClick: onAddPaymentMethod })));
    };
    const renderSubmitButton = (options) => {
        return (React.createElement(Button, { label: submitLabel, appearance: "primary", loading: isSubmitting || options?.isLoading, disabled: isDisabled, fullWidth: options?.fullWidth, onClick: () => onSubmit() }));
    };
    if (viewType === 'LOADING') {
        return children({ renderContent: () => null, renderSubmitButton, isLoading: true });
    }
    if (viewType === 'NO_PAYMENT_METHODS') {
        return (React.createElement(AddPaymentMethod, { onSuccess: onSuccess, withChargeLimit: withChargeLimit, onSubmit: onSubmit }, ({ renderForm, renderSubmitButton, isLoading: isLoadingAddPaymentMethod }) => children({
            renderContent: renderForm,
            renderSubmitButton,
            isLoading: isLoadingAddPaymentMethod || isLoading,
        })));
    }
    // viewType === 'HAS_PAYMENT_METHODS'
    return children({
        renderContent: renderPaymentMethods,
        renderSubmitButton,
        isLoading,
    });
};
